module.exports = __webpack_public_path__ + "img/四川天府新区大林中学.f13c6c94.jpg";